const techPartners = [
  { src: 'https://www.verge.io/wp-content/uploads/2024/09/Terraform-logo-2-283x300.png', alt: 'Terraform' },
  { src: 'https://www.verge.io/wp-content/uploads/2024/09/storware-logo-2-300x300.png', alt: 'Storware' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/NVIDIA_600x600-300x300.png', alt: 'NVIDIA' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/Solidigm_600x600-300x300.png', alt: 'Solidigm' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/Intel_600x600-300x300.png', alt: 'Intel' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/Inuvika_600x600_padded-300x300.png', alt: 'Inuvika' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/Ansible_600x600_padded-300x300.png', alt: 'Ansible' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/Packer_600x600_padded-300x300.png', alt: 'Packer' },
  { src: 'https://www.verge.io/wp-content/uploads/2026/02/Veeam_600x600_padded-300x300.png', alt: 'Veeam' },
  { src: 'https://www.verge.io/wp-content/uploads/2025/09/Cirrus-Data-Logo.png', alt: 'Cirrus Data' },
];

export default function TechPartnersSection() {
  const doubled = [...techPartners, ...techPartners];
  return (
    <section className="bg-[#f8fafc] py-12 overflow-hidden border-b border-gray-100">
      <div className="max-w-[1280px] mx-auto px-6 mb-6">
        <h2 className="text-xl font-bold text-center text-[#1a1a2e]">Teknoloji Ortakları</h2>
      </div>
      <div className="relative w-full overflow-hidden">
        <div className="flex gap-10 logo-marquee logo-marquee-reverse">
          {doubled.map((partner, idx) => (
            <div
              key={`${partner.alt}-${idx}`}
              className="flex-shrink-0 w-20 h-20 flex items-center justify-center"
            >
              <img
                src={partner.src}
                alt={partner.alt}
                className="max-w-full max-h-full object-contain grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
